var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3253 0.34375C1.30269 0.34375 0.464844 1.18111 0.464844 2.20312V12.4294C0.464844 13.4514 1.30269 14.2888 2.3253 14.2888H18.1388C19.1614 14.2888 19.9993 13.4514 19.9993 12.4294V2.20312C19.9993 1.18111 19.1614 0.34375 18.1388 0.34375H2.3253ZM2.3253 1.27333H18.1388C18.2697 1.27333 18.3904 1.29959 18.5022 1.34596L10.9006 7.94781C10.4773 8.31517 9.97147 8.31517 9.54889 7.94781L1.9619 1.34596C2.07366 1.29959 2.19435 1.27333 2.32526 1.27333H2.3253ZM1.40958 2.10127L8.93845 8.64543C9.67879 9.28922 10.7705 9.28806 11.511 8.64543L19.0544 2.10127C19.058 2.13548 19.069 2.16758 19.069 2.20292V12.4292C19.069 12.9522 18.6622 13.3588 18.1389 13.3588H2.32536C1.80204 13.3588 1.39524 12.9522 1.39524 12.4292V2.20292C1.39524 2.16757 1.40611 2.13547 1.40984 2.10127H1.40958Z",
    fill: "#282A30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/MailIcon.a16af38f6195304423db02b61498bc54.svg";
export { ForwardRef as ReactComponent };